import { IconProps } from '../icons';
import { themeColors } from '@styles/theme';

export const AddLayerIcon = ({ width = 24, height = 24, color = themeColors.grey }: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 4L20 8L12 12L4 8L12 4Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path d="M4 12L12 16L20 12" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M12 6.5V9.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M10.5 8H13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
